<template>
	<footer class="footer">
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-4">
					<div v-if="role">
						{{ $t('logged.in.as') }}:
						{{ login }}
						<br>
						({{ role }})
					</div>
				</div>
				<div class="col-sm-4">
					<div class="footer-contacts">
						<p class="footer_copyright">
							Frontend: Masterway {{ frontendInfo.release }} build
							{{ frontendInfo.buildVersion }} ({{ frontendInfo.buildEnvironment }}) {{ frontendInfo.buildDate }} <br>
							Backend: Masterway {{ backendInfo.release }} build
							{{ backendInfo.buildVersion }} ({{ backendInfo.buildEnvironment }}) on {{ backendInfo.buildDate }}
						</p>
					</div>
				</div>
				<div class="col-sm-4">
					Copyright © <a href="https://docura.net/">www.docura.net</a> {{ new Date().getFullYear() }} <br>
					<a href="#">Privacy Policy</a> · <a href="#">Terms & Conditions</a>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'mw-footer',
  	data () {
		return {
			frontendInfo: {
				release: process.env.VUE_APP_NODE_VERSION,
				buildVersion: process.env.VUE_APP_NODE_BUILD_VERSION,
				buildEnvironment: process.env.VUE_APP_NODE_ENV,
				buildDate: process.env.VUE_APP_NODE_BUILD_DATE
			},
			backendInfo: this.$store.getters.getApplicationInfo,
			role: null
		}
	},
	computed: {
		login () {
			return this.$store.getters.getPerson['login']
		}
	},
	methods: {
		getRole: function (load) {
			this.$store.dispatch('USER_ROLE', load)
				.then(() => {
					this.role = this.$store.getters.getRole.name
				})
		}
	},
	mounted () {
		this.getRole(true)

		const person = this.$store.getters.getPerson || {}
		window.docuraLivechatSettings = {
			openChatAfterPageLoad: location.hash === '#open-chat',
			name: [person.firstName, person.lastName].filter(Boolean).join(' '),
			email: person.login
		}

		if (!document.getElementById('docura-livechat-widget')) {
			const script = document.createElement('script')
			script.id = 'docura-livechat-widget'
			script.async = true
			script.src = 'https://redmine.docura.net/livechat/widget.js'
			script.setAttribute('data-site', 'fdbee980cbd07f7396d4a1c6')
			document.body.appendChild(script)
		}
	}
}
</script>

<style scoped>
.footer {
	font-size: 12px;
	color: #666;
	text-align: center;
	padding: 10px 0;
}
</style>
